<template>
  <el-select v-model="value" placeholder="请选择" @change="test" class="selectCss">
    <el-option
      v-for="item in partData"
      :key="item.partnerNo"
      :label="item.loginName"
      :value="item.partnerNo">
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: ["partData"],
  created() {
    //   this.value = this.$cookies.get("partner");
  },
  mounted() {
    
  },
  updated() {
    console.log(1);
    let partnerVal = this.$cookies.get("partner");
    if (partnerVal == null) {
      this.value = this.partData[0].partnerNo;
    } else {
      this.value = this.$cookies.get("partner");
    }
    
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    test() {
      this.$cookies.set("partner", this.value);
      this.$emit("change",this.value);
    }
  }
};
</script>
<style>
.selectCss {
  margin-right: 10px;
}
</style>
